import { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";

import { strCode, languages } from "../../../consts";
import { t } from "../../../services";

import {
  FlexContainers,
  Modal,
  DropdownInput,
  SmallButton,
  WrapperContainer
} from "../../../components";
import { LanguageSelectorContainer } from "./styled";

const formatLanguageOptions = (options, selectedOptions) => {
  return options
    .filter((opt) => !selectedOptions.includes(opt.id))
    .map((opt) => {
      return { ...opt, value: `${opt.id} - ${opt.value}` };
    });
};

const LanguageModal = ({ active, setActive, editedLanguage, onSave, selectedLanguages = [] }) => {
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [editTitle, setEditTitle] = useState();

  const languageOptions = useMemo(() => {
    return formatLanguageOptions(
      languages,
      selectedLanguages.filter((lang) => lang !== editedLanguage)
    );
  }, [languages, selectedLanguages]);

  useEffect(() => {
    if (!active) {
      setSelectedLanguage(null);
    }
  }, [active]);

  useEffect(() => {
    if (editedLanguage) {
      const editedOption = languageOptions.find((opt) => opt.id === editedLanguage);
      setSelectedLanguage(editedOption);
      setEditTitle(editedOption?.value);
    }
  }, [editedLanguage]);

  const handleSave = () => {
    onSave(selectedLanguage?.id);
    setSelectedLanguage(null);
    setActive(false);
  };

  const handleClose = () => {
    setSelectedLanguage(null);
    setActive(false);
  };

  return (
    <Modal
      id="language-modal"
      active={active}
      setActive={setActive}
      title={editedLanguage ? `${t(strCode.EDIT)} ${editTitle}` : t(strCode.ADD_LANGUAGE_BTN)}
      Container={LanguageSelectorContainer}
      preventOverflow={true}>
      <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={24} width={446}>
        <WrapperContainer Container={FlexContainers.FlexColumnStart} width={"100%"}>
          <DropdownInput
            id={"language-dropdown"}
            title={t(strCode.LANGUAGE_LABEL)}
            placeholder={t(strCode.SELECT_PLACEHOLDER_2)}
            options={languageOptions}
            selectedOption={selectedLanguage}
            onSelectOption={(id) =>
              setSelectedLanguage(languageOptions.find((opt) => opt.id === id))
            }
            isSearchable
          />
        </WrapperContainer>
        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={8} width={"100%"}>
          <SmallButton secondary onClick={handleClose}>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>
          <SmallButton
            onClick={handleSave}
            disabled={
              !selectedLanguage || (editedLanguage && selectedLanguage.id === editedLanguage)
            }>
            {t(strCode.SAVE_BTN)}
          </SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

LanguageModal.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  editedLanguage: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  selectedLanguages: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default LanguageModal;
